// Hacked way of handling typing without ts

export class messageRequest {
  constructor(userId, message, wsSourceId = "") {
    this.userid = userId;
    this.message = message;
    this.ws_source_id = wsSourceId;
  }
}

export class MessageResponse {
  constructor(
    id,
    msgType,
    response,
    success,
    attachments = [],
    mediaUrls = [],
    wsSourceId = null
  ) {
    this.id = id;
    this.msg_type = msgType;
    this.response = response;
    this.success = success;
    this.media_urls = mediaUrls;
    this.attachments = attachments;
    this.ws_source_id = wsSourceId;
  }
}

export class Attachment {
  constructor(url, filename) {
    this.url = url;
    this.filename = filename;
  }
}
